export default __webpack_public_path__ + "static/media/HeadingIcon.5740c39c.svg";